(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["quantity-break-selector"] && !Shopify.designMode) return;
  try {
    (function() {
    if (customElements.get('quantity-break-picker')) return;

    customElements.define('quantity-break-picker', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        self._section = self.closest('.qb-section');
        self._input = self._section ? self._section.querySelector('[data-qb-input]') : null;
        self._options = Array.from(self.querySelectorAll('.qb-option, .qb-row, .qb-pill, .qb-tile, .qb-compact-opt, .qb-float'));
        self._options.forEach(function(btn) {
          btn.addEventListener('click', function() { self._select(btn); });
        });
      }

      _select(chosen) {
        var self = this;
        var qty      = parseInt(chosen.dataset.qty, 10)      || 1;
        var total    = parseInt(chosen.dataset.total, 10)    || 0;
        var compare  = parseInt(chosen.dataset.compare, 10)  || 0;
        var discount = parseInt(chosen.dataset.discount, 10) || 0;

        self._options.forEach(function(btn) {
          btn.setAttribute('aria-pressed', btn === chosen ? 'true' : 'false');
        });

        if (self._input) self._input.value = String(qty);
        self._syncQtySelector(qty);
        self._updatePrice(total, compare > 0 && discount > 0 ? compare : 0);
      }

      _syncQtySelector(qty) {
        var qsc = document.querySelector('quantity-selector-component');
        if (!qsc) return;
        if (typeof qsc.setValue === 'function') {
          qsc.setValue(String(qty));
        } else {
          var inp = qsc.querySelector('input[type="number"]');
          if (inp) {
            inp.value = String(qty);
            inp.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (typeof qsc.updateButtonStates === 'function') qsc.updateButtonStates();
      }

      _money(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}');
        }
        return (cents / 100).toFixed(2);
      }

      _updatePrice(totalCents, compareCents) {
        var self = this;
        var nowStr = self._money(totalCents);
        var wasStr = compareCents > 0 ? self._money(compareCents) : null;
        var wrapper = document.querySelector('.price');
        if (wrapper) {
          var nowEl = wrapper.querySelector('.price__sale .price-item--sale');
          var wasEl = wrapper.querySelector('.price-item--regular.price-item--last');
          var regEl = wrapper.querySelector('.price__regular .price-item--regular');
          if (wasStr) {
            wrapper.classList.add('price--on-sale');
            if (nowEl) nowEl.textContent = nowStr;
            if (wasEl) wasEl.textContent = wasStr;
          } else {
            wrapper.classList.remove('price--on-sale');
            if (regEl) regEl.textContent = nowStr;
          }
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["truncated-text"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.truncated-text__toggle').forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var container = button.closest('.truncated-text__content');
      var short = container.querySelector('.truncated-text__short');
      var full = container.querySelector('.truncated-text__full');
      var expanded = button.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        button.setAttribute('aria-expanded', 'false');
        short.classList.remove('is-hidden');
        full.classList.remove('is-visible');
      } else {
        button.setAttribute('aria-expanded', 'true');
        short.classList.add('is-hidden');
        full.classList.add('is-visible');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
